<template>
  <el-form
    v-if="show"
    class="attribute-gallery-new-form"
    ref="attributeGalleryNewForm"
    :rules="rules"
    :model="form"
    :validate-on-rule-change="false"
    :disabled="disabled"
  >
    <h3 class="attribute-gallery-new-form__title">
      {{ title }}
    </h3>

    <el-form-item
      class="attribute-gallery-new-form__item"
      :label="$t('attr_value_new_gallery_file_name')"
      prop="fileName"
    >
      <el-input v-model="form.fileName" :disabled="editMode">
        <template slot="append">{{ fileExt }}</template>
      </el-input>
    </el-form-item>

    <el-form-item
      class="attribute-gallery-new-form__item"
      v-for="lang in languages"
      :key="lang.id"
      :label="$t('attr_value_new_gallery_description', { name: lang.name })"
      :prop="lang.id"
    >
      <el-input
        class="show-word-limit-pad"
        v-model="form[lang.id]"
        maxlength="100"
        show-word-limit
      >
        <el-button
          v-if="!lang.default"
          slot="append"
          :title="$t('system_translate')"
          icon="el-icon-magic-stick"
        ></el-button>
      </el-input>
    </el-form-item>

    <el-form-item
      class="attribute-gallery-new-form__item"
      :label="$t('attr_value_new_gallery_order_num')"
      prop="numberInOrder"
    >
      <el-input-number v-model="form.numberInOrder"></el-input-number>
    </el-form-item>

    <el-form-item class="attribute-gallery-new-form__item">
      <el-checkbox v-model="form.preview" :disabled="!galleryNames.length">
        {{ $t("attr_value_new_gallery_main") }}
      </el-checkbox>
    </el-form-item>

    <el-form-item
      class="attribute-gallery-new-form__item attribute-gallery-new-form_action"
    >
      <el-button type="success" @click="submitForm('attributeGalleryNewForm')">
        {{ $t("attr_value_new_gallery_save") }}
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "AttributeValueGalleryNewForm",
  components: {},
  props: {
    fileName: String,
    title: String,
    languages: Array,
    disabled: {
      type: Boolean,
      default: false
    },
    galleryNames: Array,
    nextOrderNum: Number,
    editableObject: Object,
    editMode: Boolean
  },
  data() {
    return {
      show: false,
      fileExt: "",
      form: {
        fileName: "",
        numberInOrder: 1,
        preview: false
      },
      presetRules: {
        fileName: [
          {
            required: true,
            message: this.$t("attr_value_new_gallery_file_name_rule"),
            trigger: "change"
          },
          {
            validator: this.dublicateFileNameValidator,
            trigger: "change"
          }
        ]
      },
      rules: {}
    };
  },
  computed: {},
  methods: {
    setFileName() {
      if (this.fileName) {
        let fn = this.fileName.split(".");
        if (fn.length) {
          this.fileExt = `.${fn.pop()}`;
          this.form.fileName = fn.join(".");
        }
      }
    },
    setNameProps() {
      let form = {
        fileName: this.form.fileName || "",
        numberInOrder: this.editableObject.numberInOrder || this.nextOrderNum,
        preview:
          this.editableObject.preview !== undefined
            ? this.editableObject.preview
            : this.galleryNames.length == 0
      };

      this.languages.forEach(lang => {
        if (!form[lang.id]) {
          form[lang.id] = this.editableObject[lang.id] || "";
        }
      });

      this.form = form;
    },
    setRuleName() {
      let rule = {};
      this.languages
        .filter(lang => lang.default)
        .forEach(lang => {
          rule[lang.id] = [
            {
              required: true,
              message: this.$t("attr_value_new_gallery_description_rule"),
              trigger: "change"
            }
          ];
        });
      let rules = { ...this.presetRules, ...rule };
      this.rules = rules;
    },
    close() {
      this.$emit("close");
    },
    save() {
      let result = { ...this.form };
      result.fileName = result.fileName + this.fileExt;
      this.$emit("save", result);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
          this.initLocalState();
        } else {
          return false;
        }
      });
    },
    initLocalState() {
      this.show = false;
      this.$nextTick(function () {
        this.setFileName();
        this.setNameProps();
        this.setRuleName();
        this.show = true;
      });
    },
    dublicateFileNameValidator(rule, value, callback) {
      let name = (value + this.fileExt).toLowerCase();
      if (!this.editMode && this.galleryNames.some(n => n === name)) {
        callback(
          new Error(this.$t("attr_value_new_gallery_file_name_dublicate_rule"))
        );
      } else {
        callback();
      }
    },
    changePreviewPhoto() {
      if (!this.editableObject || this.editableObject.preview === undefined) {
        if (this.galleryNames.length > 0) {
          this.form.preview = false;
        }
      }
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.initLocalState();
    });
  },
  watch: {
    fileName: function () {
      this.setFileName();
    },
    languages: function () {
      this.setNameProps();
      this.setRuleName();
    },
    nextOrderNum: function (val) {
      this.form.numberInOrder = val;
    },
    galleryNames: function () {
      this.changePreviewPhoto();
    }
  }
};
</script>

<style lang="scss">
@import "@/css/variables.scss";

.attribute-gallery-new-form {
  .attribute-gallery-new-form__title {
    text-align: left;
    padding: $form_title_padding;
  }

  .attribute-gallery-new-form__item {
    padding: $form_item_padding;
  }

  .attribute-gallery-new-form__action {
    text-align: right;
  }
}
</style>
